import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["plannedYear", "recommendedYear"];

  replaceYear() {
    this.plannedYearTarget.value = this.recommendedYearTarget.textContent;
    this.plannedYearTarget.dispatchEvent(new Event("change"));
  }
}
